/* eslint-disable */
/* tslint:disable */
import React from 'react';
export default ({ style }) => (React.createElement("svg", { className: "slideshow-arrow", style: style, width: "40px", height: "33px", viewBox: "0 0 40 33", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
    React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
        React.createElement("g", { id: "Artboard-Copy-93", transform: "translate(-28.000000, -32.000000)", fillRule: "nonzero" },
            React.createElement("polygon", { id: "4", points: "51.5515789 32 67.6 48.0484211 51.5515789 64.0968421 46.9663158 59.5115789 54.9880947 51.4881326 28 51.4897902 28 44.9245271 55.30728 44.9243284 46.9663158 36.5852632" })))));
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=arrow2.js.map